import { render } from "./CreateProfile.vue?vue&type=template&id=160a960f&scoped=true"
import script from "./CreateProfile.vue?vue&type=script&lang=js"
export * from "./CreateProfile.vue?vue&type=script&lang=js"

import "./CreateProfile.vue?vue&type=style&index=0&id=160a960f&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-160a960f"

export default script